
function saveToLocalStorage(key, value) {
    if (value) return window.localStorage.setItem(key, value);
    window.localStorage.removeItem(key);
}

/**
 * Will load a reducer state from storage by it's name, if it does not exist it will return
 * the provided default Object
 * @param {*} name Name of the reducer
 * @param {*} defaultObj User provided default object
 */
export function localStorageOrDefault(name, defaultObj) {
    const local = window.localStorage.getItem(name);
    if (local) return JSON.parse(local);
    return defaultObj;
}

/**
 * Wraps a reducer so that it's state is always backed up in localStorage
 * @param {*} reducer The reducer you want to cache in local storage
 * @returns reducer
 */
export function cacheInLocalStorage(reducer) {
    return function (state, action) {
        let newState = reducer(state, action);
        if (action.type === 'USERINFO::LOGOUT') { newState = {} }
        saveToLocalStorage(reducer.name, JSON.stringify(newState));
        return newState;
    }
}
